import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { FiMail, FiLock, FiAlertCircle } from 'react-icons/fi';
import logo from '../assets/images/logos/logo.svg';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    
    if (!email || !password) {
      setError('Por favor, preencha todos os campos');
      return;
    }
    
    setLoading(true);
    
    try {
      const { error: loginError } = await login(email, password);
      
      if (loginError) {
        if (loginError.message === 'Invalid login credentials') {
          setError('Email ou senha incorretos');
        } else {
          setError(loginError.message || 'Erro ao fazer login');
        }
      }
    } catch (err: any) {
      setError(err?.message || 'Ocorreu um erro durante o login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cinza-escuro p-4 font-montserrat">
      <div className="w-full max-w-md space-y-8 relative overflow-hidden rounded-xl bg-gray-900 shadow-2xl">
        {/* Faixa vermelha superior */}
        <div className="h-2 w-full bg-vermelho-claro absolute top-0 left-0"></div>
        
        <div className="p-8">
          <div className="text-center">
            <img src={logo} alt="Logo" className="h-12 mx-auto mb-4" />
            <p className="text-branco-acinzentado text-lg">
              Portal do Cliente
            </p>
            <div className="flex justify-center mt-6 mb-8">
              <div className="h-1 w-16 bg-vermelho-escuro rounded"></div>
            </div>
          </div>
          
          {error && (
            <div className="bg-red-900/30 border border-red-800 rounded-md p-3 mb-5 flex items-center text-red-200 animate-fade-in">
              <FiAlertCircle className="mr-2 flex-shrink-0 text-red-400" />
              <span>{error}</span>
            </div>
          )}
          
          <form className="mt-4 space-y-6" onSubmit={handleSubmit}>
            <div className="space-y-5">
              <div>
                <label htmlFor="email" className="text-sm font-medium text-branco-acinzentado block mb-1">
                  Email
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiMail className="text-gray-500" />
                  </div>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input pl-10 bg-gray-800 focus:ring-vermelho-claro focus:border-vermelho-claro"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="password" className="text-sm font-medium text-branco-acinzentado block mb-1">
                  Senha
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiLock className="text-gray-500" />
                  </div>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="input pl-10 bg-gray-800 focus:ring-vermelho-claro focus:border-vermelho-claro"
                    placeholder="••••••••"
                  />
                </div>
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className={`btn w-full flex justify-center items-center py-3 bg-vermelho-claro hover:bg-vermelho-escuro text-white transition-all duration-300 ${
                  loading ? 'opacity-70 cursor-not-allowed' : ''
                }`}
              >
                {loading ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
                ) : (
                  'Entrar'
                )}
              </button>
            </div>
          </form>
          
          <div className="mt-8 pt-6 text-center text-sm text-gray-400 border-t border-gray-800">
            <p>Entre em contato com o administrador se tiver problemas no acesso.</p>
            <p className="mt-4 font-raleway text-xs text-gray-600">
              © {new Date().getFullYear()} Portal do Cliente - Todos os direitos reservados
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 